'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _pcSlateTools = require('./../process/pc-slate-tools');

var _ShopifySection2 = require('./../sections/ShopifySection');

var _Responsive = require('./../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Selectors
/*
 *  Product Template Scripts
 *    Scripts that are only meant to run on the Product Template.
 *
 *  Version:
 *    1.0.0 - 2020/03/12
 */

var CART_TEMPLATE_CONTAINER = '[data-cart-template]';
var COUNTER_SELECTOR = '[data-header-cart-count]';
var CART_ITEM_CONTAINER = '[data-cart-item-container]';
var REMOVE_BUTTON = '[data-remove-cart-item]';
var BUTTON_MINUS = '[data-quantity-selector-minus]';
var BUTTON_PLUS = '[data-quantity-selector-plus]';
var QUANTITY_BOX = '[data-quantity-selector-field]';
var CLASS_HIDDEN = 'is-hidden';
var SUBTOTAL_CONTAINER = '[data-cart-subtotal]';
var FREE_SHIPPING_CONTAINER = '[data-cart-free-shipping]';
var PROGRESS_BAR_CONTAINER = '[data-free-shipping-progress]';
var NOTE_CONTAINER = '[data-cart-note]';
var FREE_SHIPPING_LIMIT = 3000;

var CartTemplate = function (_ShopifySection) {
	(0, _inherits3.default)(CartTemplate, _ShopifySection);

	function CartTemplate(container) {
		(0, _classCallCheck3.default)(this, CartTemplate);

		var _this = (0, _possibleConstructorReturn3.default)(this, (CartTemplate.__proto__ || Object.getPrototypeOf(CartTemplate)).call(this, container));

		_this.container = container;
		_this.itemContainer = container.find(CART_ITEM_CONTAINER);
		_this.subTotalContainer = container.find(SUBTOTAL_CONTAINER);
		_this.freeShippingContainer = container.find(FREE_SHIPPING_CONTAINER);
		_this.progressBarContainer = container.find(PROGRESS_BAR_CONTAINER);
		_this.noteContainer = container.find(NOTE_CONTAINER);

		//Elements
		_this.removeContainer = container.find(REMOVE_BUTTON);
		container.on('click', REMOVE_BUTTON, function (e) {
			return _this.onRemoveClick(e);
		});
		container.on('click', BUTTON_MINUS, function (e) {
			return _this.qtyProcess(e, 0);
		});
		container.on('click', BUTTON_PLUS, function (e) {
			return _this.qtyProcess(e, 1);
		});
		container.on('change', QUANTITY_BOX, function (e) {
			return _this.onChangeItem(e);
		});
		container.on('blur', NOTE_CONTAINER, function (e) {
			return _this.onNoteAdd(e);
		});

		return _this;
	}

	(0, _createClass3.default)(CartTemplate, [{
		key: 'onNoteAdd',
		value: function onNoteAdd(e) {
			var self = (0, _jquery2.default)(e.currentTarget);
			var note = self.val();
			console.log(note);
			(0, _pcSlateTools.setCartNote)(note);
		}
	}, {
		key: 'updateButton',
		value: function updateButton() {
			var cart = (0, _pcSlateTools.getCurrentCart)();
			//Update header cart counter
			this.updateCounter(cart.item_count);
			//Display empty cart msg
			if (cart.item_count == 0) {
				this.emptyCart();return false;
			}
			// update cart subtotal
			this.updateCartSubTotal(cart.total_price);
			//TODO: update inventory data max and min values for quantity selector
		}
	}, {
		key: 'qtyProcess',
		value: function qtyProcess(e, t) {
			var _this2 = this;

			e.preventDefault();
			e.stopPropagation();
			(0, _jquery2.default)('body').addClass('loading');
			var self = (0, _jquery2.default)(e.currentTarget);
			var max = self.closest('div.cart-item__actions').find('[data-quantity-selector]').data("max");
			var qty_field = self.closest("div").find("input[name=qty]");
			var qty = qty_field.val();
			if (t == 0) {
				if (qty > 1) qty--;else {
					self.attr("disabled", true);(0, _jquery2.default)('body').removeClass('loading');return false;
				}
				self.closest("div").find(".is-plus").attr("disabled", false);
			} else {
				if (max == null || qty < max) qty++;else {
					self.attr("disabled", true);(0, _jquery2.default)('body').removeClass('loading');return false;
				}
				self.closest("div").find(".is-minus").attr("disabled", false);
			}
			qty_field.val(qty);
			(0, _pcSlateTools.updateCart)(qty_field.data('index'), qty);
			(0, _jquery2.default)(document).on(_pcSlateTools.ON_CART_FINISHED, function () {
				return _this2.onUpdateItem(self, qty_field.data('index'));
			});
		}
	}, {
		key: 'onUpdateItem',
		value: function onUpdateItem(o, i) {
			var cart = (0, _pcSlateTools.getCurrentCart)();
			//Update header cart counter
			this.updateCounter(cart.item_count);
			//update cart sub total
			this.updateCartSubTotal(cart.total_price);
			cart.items.forEach(function (item, index) {
				if (item.id == i) {
					o.closest('div.cart-item__actions').find('.cart-item__price').html('Price: ' + (0, _pcSlateTools.formatMoney)(item.final_line_price, window.Currency.format));
					return false;
				}
			});
		}
	}, {
		key: 'updateCartSubTotal',
		value: function updateCartSubTotal(amount) {
			this.subTotalContainer.html('Subtotal: ' + (0, _pcSlateTools.formatMoney)(amount, window.Currency.format));
			var free_msg = "";
			var width = "";
			if (amount >= FREE_SHIPPING_LIMIT) {
				free_msg = "Congratulations! You're eligible for free shipping!";
				width = "100%";
			} else {
				free_msg = "You're " + (0, _pcSlateTools.formatMoney)(FREE_SHIPPING_LIMIT - amount, window.Currency.format) + " away from free shipping!";
				width = 100 - Math.round((FREE_SHIPPING_LIMIT - amount) * 100 / FREE_SHIPPING_LIMIT) + '%';
			}
			this.freeShippingContainer.html(free_msg);
			this.progressBarContainer.css('width', width);
			(0, _jquery2.default)('body').removeClass('loading');
		}
	}, {
		key: 'onChangeItem',
		value: function onChangeItem(e) {
			var _this3 = this;

			var self = (0, _jquery2.default)(e.currentTarget);
			var max = self.closest('div.cart-item__actions').find('[data-quantity-selector]').data("max");console.log(max);
			var q = self.val();
			var line = self.data('index');
			self.closest("div").find(".is-minus").attr("disabled", false);self.closest("div").find(".is-plus").attr("disabled", false);
			if (q <= 1) {
				self.closest("div").find(".is-minus").attr("disabled", true);q = 1;self.val(q);
			}
			if (max != null && q >= max) {
				self.closest("div").find(".is-plus").attr("disabled", true);q = max;self.val(q);
			}
			(0, _jquery2.default)('body').addClass('loading');
			(0, _pcSlateTools.updateCart)(line, q);
			(0, _jquery2.default)(document).on(_pcSlateTools.ON_CART_FINISHED, function () {
				return _this3.onUpdateItem(self, line);
			});
		}
	}, {
		key: 'emptyCart',
		value: function emptyCart() {
			var emptyWrap = (0, _jquery2.default)('<div>', { class: 'cart-empty__wrap' });
			emptyWrap.append((0, _jquery2.default)('<p>', { class: 'cart-empty__msg', text: 'Your cart is empty' }));
			emptyWrap.append((0, _jquery2.default)('<a>', { class: 'o-btn', text: 'Continue Shopping', href: '/' }));
			(0, _jquery2.default)('.c-cart-template').html(emptyWrap);
			(0, _jquery2.default)('body').removeClass('loading');
		}
	}, {
		key: 'onRemoveClick',
		value: function onRemoveClick(e) {
			var _this4 = this;

			e.preventDefault();
			e.stopPropagation();
			(0, _jquery2.default)('body').addClass('loading');
			var self = (0, _jquery2.default)(e.currentTarget);
			var id = self.data("cartRemoveVariant");

			try {
				(0, _pcSlateTools.removeFromCart)(id);
				self.closest("div.cart-item__container").remove();
				var qty = self.closest('[data-cart-item-container]').find('[data-quantity-selector-field]').val();
				var price = self.closest('[data-cart-item-container]').find('.cart-item__price').html();
				var name = self.closest('[data-cart-item-container]').find('.cart-item__product-title').html();
				var sku = self.closest('[data-cart-item-container]').find('.cart-item__product-code').html();

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'page_type': 'remove_from_cart',
					'event': 'MagnetUK_remove_from_cart', //create a custom event in GTM
					'items': [{
						'item_id': sku.replace('Code: ', ''),
						'item_name': name,
						'price': price.replace('Price: $', ''),
						'item_brand': 'AMF Magnets',
						'quantity': qty
					}]
				});
			} catch (e) {
				console.error(e);
				if (e.description) alert(e.description);
				(0, _jquery2.default)('body').removeClass('loading');
				return;
			}

			(0, _jquery2.default)(document).on(_pcSlateTools.ON_CART_FINISHED, function () {
				return _this4.updateButton();
			});
		}
	}, {
		key: 'updateCounter',
		value: function updateCounter(count) {
			(0, _jquery2.default)(COUNTER_SELECTOR).html(count);

			if (count <= 0) {
				(0, _jquery2.default)(COUNTER_SELECTOR).addClass(CLASS_HIDDEN);
			}
		}
	}]);
	return CartTemplate;
}(_ShopifySection2.ShopifySection);

(0, _ShopifySection2.register)(CART_TEMPLATE_CONTAINER, CartTemplate);